import {useTranslation} from 'react-i18next';
import ICON_APPLE_LIGHT from '../../../public/static/auth/login-ico-sns-apple-32-light.svg';
import ICON_APPLE from '../../../public/static/auth/login-ico-sns-apple-32.svg';
import ICON_FACEBOOK from '../../../public/static/auth/login-ico-sns-fb-32.svg';
import ICON_GOOGLE from '../../../public/static/auth/login-ico-sns-google-32.svg';
import ICON_LINE from '../../../public/static/auth/login-ico-sns-line-32.svg';
import Text from '../../common/component/Text';
import useTheme from '../../common/hook/useTheme';
import {ITheme} from '../../common/type';
import TextButton from '../../ui/button/TextButton';
import {LOGIN_METHOD_TEXT} from '../common';
import {ILastLoginAuth, IGlobalLoginMethod} from '../type';

interface IProps {
  lastLoginAuth: ILastLoginAuth;
  goLoginModal: () => void;
  onClickLoginSns: (loginMethod: IGlobalLoginMethod) => void;
}

export default function LastLogin({
  lastLoginAuth,
  goLoginModal,
  onClickLoginSns,
}: IProps) {
  const {t} = useTranslation();
  const {emailOrName, loginMethod} = lastLoginAuth;
  const {theme} = useTheme();
  const {icon, buttonCn, textCn, textKey} =
    LAST_LOGIN_BTN_MAP[theme][loginMethod];

  return (
    <>
      <Text className="s14-regular-grey13 text-center">
        {t('login_global_existing_account_popup', {existing: emailOrName})}
      </Text>
      <TextButton
        className={cn(buttonCn, 'w-full h-50 mt-26 mb-22 px-10')}
        textClassName={cn(textCn, 'flex-center')}
        onClick={() => onClickLoginSns(loginMethod)}
      >
        <img
          src={icon}
          alt={LOGIN_METHOD_TEXT[loginMethod]}
          width={24}
          height={24}
          className="mr-6"
        />
        {t(textKey)}
      </TextButton>
      <TextButton
        className="btn-transparent text-center mb-2"
        textClassName="s13-regular-grey06 underline"
        onClick={goLoginModal}
      >
        {t('login_global_existing_other_option_button')}
      </TextButton>
    </>
  );
}

const LAST_LOGIN_BTN_MAP: {
  [key in ITheme]: {
    [key in IGlobalLoginMethod]: {
      icon: string;
      buttonCn: string;
      textCn: string;
      textKey: string;
    };
  };
} = {
  light: {
    GG: {
      icon: ICON_GOOGLE,
      buttonCn: 'btn-white-grey-06',
      textCn: 's16-medium-grey08',
      textKey: 'login_global_account_google',
    },
    FB: {
      icon: ICON_FACEBOOK,
      buttonCn: 'btn-facebook-blue',
      textCn: 's16-medium-white',
      textKey: 'login_global_account_facebook',
    },
    AP: {
      icon: ICON_APPLE_LIGHT,
      buttonCn: 'btn-black',
      textCn: 's20-medium-white',
      textKey: 'login_global_account_apple',
    },
    LN: {
      icon: ICON_LINE,
      buttonCn: 'btn-line-green',
      textCn: 's16-medium-white',
      textKey: 'login_global_account_line',
    },
  },
  dark: {
    GG: {
      icon: ICON_GOOGLE,
      buttonCn: 'btn-white',
      textCn: 's16-medium-grey08',
      textKey: 'login_global_account_google',
    },
    FB: {
      icon: ICON_FACEBOOK,
      buttonCn: 'btn-facebook-blue',
      textCn: 's16-medium-white',
      textKey: 'login_global_account_facebook',
    },
    AP: {
      icon: ICON_APPLE,
      buttonCn: 'btn-white',
      textCn: 's20-medium-black',
      textKey: 'login_global_account_apple',
    },
    LN: {
      icon: ICON_LINE,
      buttonCn: 'btn-line-green',
      textCn: 's16-medium-white',
      textKey: 'login_global_account_line',
    },
  },
};
